import { render, staticRenderFns } from "./AccountManage.vue?vue&type=template&id=b06f5ffa&scoped=true"
import script from "./AccountManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountManage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccountManage.vue?vue&type=style&index=0&id=b06f5ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06f5ffa",
  null
  
)

export default component.exports